
import { Component, HostListener, OnDestroy} from '@angular/core'
import { CtEmailFormComponent, CtButtonComponent, ApiResponseModel,AuthService, Action, CtInputTextComponent, HttpService, PlusAlertsService, FormatTimePipe, EntityField, CtDialogComponent, CtPanelComponent, CtButtonUncompressedContainerComponent} from 'components';
import {Subscription, timer } from 'rxjs';
import { BaseController } from './base.controller';
import { Router } from '@angular/router';


@Component({
	selector: 'av-vi05',
	template: `<div [id]="getId()" #target><div>`
})

export class AvVi05 extends BaseController implements OnDestroy{

	private readonly SEND_TIMEOUT_MINUTES: number = 10;
	private sendTimer: Subscription;
	private sendBtn: CtButtonComponent;
  private sendDialog: CtDialogComponent;
	private formatter: FormatTimePipe;
	private recipients: string[];
	public counter: number;
	public numCliente: number;
  private estadoDeCuentaDialog: CtDialogComponent;

	//util 
	private subscriptions : Subscription[] = [];

	constructor(plusAlertService: PlusAlertsService, private authService: AuthService, private router: Router) {
		super();
		super.setViewCode('AV_VI05');
		this.formatter = new FormatTimePipe();
	}
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
   this.validateBtnEnviar();
  }

	/* ---------------------- CONTROLLER LOGIC ------------------- */
	public setNumClientefromLoggedUser(action: Action): void {
		const input: CtInputTextComponent = this.utilService.getComponentRef("txtCtInputText_04eeb95c");
    this.estadoDeCuentaDialog = this.utilService.getComponentRef("diaCtDialog_245a912a");
		this.storeService.setState('numCliente',this.authService.loggedUser.user.num_cliente_sigma);
	
		this.subscriptions.push(this.storeService.getStateObservable('numCliente').subscribe({
		  next: (value) => {
			this.numCliente = value;
			input.setValue(this.numCliente);
		  }
		}));
	  }

  private unhidePanelCred() {
    const panelCred: CtPanelComponent = this.utilService.getComponentRef("pnlCtPanel_CredPending");
    panelCred.setHidden(false);
  }

  public checkChildButtons(action: Action){
    let containerMisCred: CtButtonUncompressedContainerComponent = this.utilService.getComponentRef(action.actionParams[0]);
    let cantidadChilds = containerMisCred.getChildElements().length;
    if(cantidadChilds == 0 ){
      this.unhidePanelCred();
    }
  }
	
  sendReportViaEmail(e: any): void {
    let emailForm: CtEmailFormComponent = this.view.getChildById(this.utilService.getParsedId(e.actionParams[0]), true);
    let recipients = emailForm.recipients.map((x) => x.value) || [];
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (recipients[0] == '' || !recipients[0] ) {
      this.plusAlertService.setCtDialogInfo('ERROR', 'downloadError', 'downloadError', 'primary', 'Debe ingresar un correo',
        true, 'Aceptar', 'Cancelar');
    }else if(!emailRegex.test(recipients[0])){
      this.plusAlertService.setCtDialogInfo('ERROR', 'downloadError', 'downloadError', 'primary', 'Correo electrónico no válido',
      true, 'Aceptar', 'Cancelar');
    }else{
    this.recipients = [];

    for (let email of recipients) {
      if (email)
        this.recipients.push(email);
    }

    if (!this.sendDialog)
    this.sendDialog = this.utilService.getComponentRef("diaCtDialog_245a912aEnviarEmail");

    this.sendBtn = this.utilService.getComponentRef("CtButton_default_0")
    this.sendDialog.event2('onCustomEvent');
    this.sendDialog.closeDialog();
  }
  }

//Download logic
  public downloadReport(action : Action): void {
	const reportData = this.getReportData(this.numCliente);
	this.requestReportData(reportData);
}

  private getReportData(num_cliente: number): any {
	return {
		"format": "PDF",
		"source": this.getViewCode(),
		"sendTo": null,
		"requireDownloadURL":false,
		"parameters": [
		  {
			"name": "P_NUM_CLIE",
			"value": num_cliente
		  },
		  {
			"name": "P_FEC_CAL",
			"value": this.datePipe.transform(new Date(), 'd/M/yyyy')
		  },
		  {
			"name": "P_NUM_EMP",
			"value": "5"
		  }
		]
	  };
  }

  private requestReportData(reportData: any){
	this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/Report/Generate/ST_RE10', reportData).subscribe({
		next : (data : any) => {
			const report : any = data.data[0];
			this.downloadOnBrowser(report);
      let btnDescargarCorreoMessage = this.utilService.getComponentRef('CtMessage_2605b7b4Downloaded');
      btnDescargarCorreoMessage.setHidden(false);
      this.estadoDeCuentaDialog.closeDialog();
		},
		error : (error : any) => {
			this.plusAlertService.setCtDialogInfo('Descarga del estado de cuenta fallida.', 'error',
				'error', 'primary', 'Lo sentimos, la descarga del estado de cuenta no se pudo completar. Por favor, verifica que tu conexión a Internet está funcionando correctamente y luego intenta descargar el reporte una vez más.',
				true, 'Finalizar', 'Cancelar');
		}
	}));

  }

 private downloadOnBrowser(report: any) {
    try {
      let byteArray = this.utilService.getByteArray(report);
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      this.utilService.createAdownloadATag(blob, 'ESTADO_CUENTA_' + this.loggedUser.user.num_cliente_sigma);
    } catch (error) {
      throw new Error("");
    }
  }

  startTimer(e: any): void {
    let htmlEmailList = '<br><br><ul>';
    let emailForm: CtEmailFormComponent = this.utilService.getComponentRef("ctemCtEmailForm_8bf99441");
    let recipients = emailForm.recipients.map((x) => x.value) || [];
    recipients.forEach(x => htmlEmailList += '<li>' + x + '</li>');
    htmlEmailList += '</ul>'
    this.sendDialog = this.utilService.getComponentRef("diaCtDialog_245a912aEnviarEmail");
    this.sendDialog.closeDialog();

    this.plusAlertService.setCtDialogInfo('Correo enviado', 'success', 'success', 'primary', 'El estado de cuenta ha sido enviado de manera correcta a los correos ingresados.',
      true, 'Finalizar', '');

    this.counter = this.SEND_TIMEOUT_MINUTES * 60;
    let sendBtn = document.getElementById("btnEnviarCorreo") as HTMLButtonElement;
    sendBtn.disabled = true;
    this.subscriptions.push(this.sendTimer = timer(0, 1000).subscribe(() => {
      if (this.counter == 0)
        this.stopTimer();
      else {
        --this.counter;
        sendBtn.innerText = `REINTENTAR EN ${this.formatter.transform(this.counter)}`;
      }
    }));
  }

  private stopTimer(): void {
    let sendBtn = document.getElementById("btnEnviarCorreo") as HTMLButtonElement;
    this.sendTimer.unsubscribe();
    this.counter = 0;
    sendBtn.disabled = false;
    sendBtn.innerText = 'ENVIAR';
  }

  validateBtnEnviar(): void {
    let emailForm: CtEmailFormComponent = this.utilService.getComponentRef("ctemCtEmailForm_8bf99441");
    let recipients = emailForm.recipients.map((x) => x.value) || [];
    let btnAgregar = document.getElementById("btnAgregarCorreo");
    
      if (recipients.length >= 1 || (btnAgregar && btnAgregar.getAttribute('disabled') !== 'disabled')) {
       
        if (this.sendBtn) {
          this.sendBtn.setDisabled(false);
        }
      } else {
        if (this.sendBtn) {
          this.sendBtn.setDisabled(true);
        }
      }
  }

  // funcion de onClick de los botones
  public ActionBtnChild(action: Action): void {
	this.NavigateTo(action);
  }

  public NavigateTo(action: Action): void{
	let buttonID: string = action.utilParams[0] as unknown as string
	const button : CtButtonComponent = this.view.getChildById(buttonID, true)
	this.storeService.setState('isEditing', true);
    let numObjeto;
    let nombreObjeto;
    button.getValue().ArrayEntities.List.forEach((entity: EntityField) => {
      if (entity.Name === 'NUM_OBJETO') numObjeto = parseInt(entity.Value);
      if (entity.Name === 'BUTTON_TEXT') nombreObjeto = entity.Value;
    });
    this.storeService.setState('NUM_OBJETO', numObjeto);
    this.storeService.setState('NOMBRE_OBJETO', nombreObjeto);
    this.router.navigate(['home/view/AV_VI05/AV_VI11']);
  }

  private navigateSolicitudCred() {
    this.router.navigate(['home/view/AV_VI01']);
  }

	/* -------------------- END CONTROLLER LOGIC ----------------- */

}